import { isIE } from './helper';

// IE9特殊处理
if (isIE(9)) {
  const bodyEl = document.body;
  bodyEl.className += ' IE9';
}
